import React from 'react'
import { Helmet } from 'react-helmet'
import { subscribe } from 'react-contextual'
import styles from './PropertyView.module.scss'
import PropertiesProvider from 'modules/properties/PropertiesProvider'
import { DimmerLoader } from '../../../../views/components'
import PropertyInfo from './PropertyInfo/PropertyInfo'
import PropertyAttachments from './PropertyAttachments/PropertyAttachments'
import Close from 'views/components/atoms/Svgs/Close'

const PropertyView = ({ viewData, closeProperty }: any) => {
  return (
    <>
      <Helmet>
        <title>reOS | Properties | {viewData.title}</title>
      </Helmet>
      <DimmerLoader className={styles.root} loading={viewData.isLoading} bgColor={'appBg'}>
        <header className={styles.header}>
          <button className={styles.close} onClick={closeProperty}>
            <Close />
          </button>
        </header>
        <div className={styles.body}>
          <div className="rbn--row">
            <div className="rbn--col rbn-col-md-8">{<PropertyAttachments />}</div>
            <div className="rbn--col rbn-col-md-8">
              <PropertyInfo viewData={viewData} />
            </div>
          </div>
        </div>
      </DimmerLoader>
    </>
  )
}

export default subscribe([PropertiesProvider], ({ viewData, closeProperty }: any) => ({
  viewData,
  closeProperty,
}))(PropertyView)
